import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import { Edit3Icon } from 'components/shared/Icon/model'

import styles from '../ActionButtons.module.scss'

export const EditButton = ({
  ariaLabel,
  className = undefined,
  size = 'medium',
  onClick,
  isDisabled,
}) => (
  <Button
    className={cx(styles.button, { [className]: Boolean(className) })}
    icon={Edit3Icon}
    variant="outlined"
    {...{ ariaLabel, size, onClick, isDisabled }}
  />
)
